import { render, staticRenderFns } from "./ProductCreated.vue?vue&type=template&id=73905065&scoped=true&"
import script from "./ProductCreated.vue?vue&type=script&lang=js&"
export * from "./ProductCreated.vue?vue&type=script&lang=js&"
import style0 from "./ProductCreated.vue?vue&type=style&index=0&id=73905065&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73905065",
  null
  
)

export default component.exports